module.exports = __webpack_public_path__ + "static/media/blog4.a2a584b2.jpg";